import React from 'react';
import Statement2 from './Statement2';
import Blog from './Blog';
import Chat from './Chat';
import Task from './Task';
import Contact from './Contact';
import Footer from './Footer';
import Fade from 'react-reveal';

export default function Pagework(){
    return(
        <>
            <Fade top distance = '10%' duration = {1000}>
                <Statement2 />
                <Blog />
                <Chat />
                <Task />
                <Contact />
                <Footer />
            </Fade>
        </>
    );
}